const breakpoints = {
    xs: '0px',
    s: '768px',
    m: '1024px',
    l: '1280px',
};

export { breakpoints };
//# sourceMappingURL=breakpoints.js.map
